module.exports = "<p>\n  sidebar works!\n</p>\n"